import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import { getHistories, updateHistory } from '@/plugins/firebase-monitoring';

import * as types from './mutation-types';

export function setMonitoringHistories({ commit }, { histories }) {
  commit(types.SET_MONITORING_HISTORIES, histories);

  return Promise.resolve(histories);
}

export function fetchMonitoringHistories({ dispatch, getters }) {
  return getHistories(getters.getCurrentDate, getters.currentUserId)
    .then(histories => dispatch('setMonitoringHistories', {
      histories,
    }));
}

function quizType(cat) {
  if (cat.quiz_count === 3) {
    return 'preparation';
  } else if (cat.quiz_count === 5) {
    return 'review';
  }
  return 'evaluation';
}

export function startQuizMonitoring({ getters, state }, { cat, catPage, quizResult }) {
  if (quizResult !== undefined) {
    return true;
  }

  const histories = getters.getMonitoringHistories;
  const newHistories = histories.concat({
    core_concept_id: catPage.core_concept_id,
    created_at: state.startTime,
    duration: 0,
    screens: [
      cat.subject.name,
      catPage.chapter_name,
    ],
    subject_id: catPage.subject_id,
    tid: catPage.id,
    title: null,
    type: quizType(cat),
    unit_id: catPage.unit_id,
    cat_id: cat.id,
    is_correct: null,
    platform: 'web',
  });

  return updateHistory(getters.getCurrentDate, getters.currentUserId, newHistories);
}

export function endQuizMonitoring({ dispatch, getters, state }, { cat, catPage, quizResult }) {
  const histories = getters.getMonitoringHistories;
  const newHistories = histories.concat({
    core_concept_id: catPage.core_concept_id,
    created_at: state.startTime,
    duration: quizResult.duration,
    screens: [
      cat.subject.name,
      catPage.chapter_name,
    ],
    subject_id: catPage.subject_id,
    tid: catPage.id,
    title: null,
    type: quizType(cat),
    unit_id: catPage.unit_id,
    cat_id: cat.id,
    is_correct: quizResult.is_correct,
    platform: 'web',
  });

  updateHistory(getters.getCurrentDate, getters.currentUserId, newHistories);

  dispatch('setMonitoringHistories', {
    histories: newHistories,
  });
}

export function setCatsPage({ commit }, { catPage }) {
  commit(types.SET_CATS_PAGE, { catPage });

  return Promise.resolve(catPage);
}

export function setCatsPageIdList({ commit }, { catPageId, catPageIdIndex }) {
  commit(types.SET_CATS_PAGE_ID, { catPageId, catPageIdIndex });

  return Promise.resolve(catPageId);
}

export function fetchCatsPage({ dispatch }, { catId, catPageIdIndex }) {
  return http.get(`${MINERVA_API_URL}/cats/${catId}/next-quiz`)
    .then((resp) => {
      dispatch('setCatsPageIdList', { catPageId: resp.data.id, catPageIdIndex });
      return dispatch('setCatsPage', { catPage: resp.data });
    })
    .catch(err => Promise.reject(err.response));
}

export function fetchResultCatsPage({ dispatch }, { catPageId }) {
  return http.get(`${MINERVA_API_URL}/pages/${catPageId}`)
    .then(resp => dispatch('setCatsPage', { catPage: resp.data }))
    .catch(err => Promise.reject(err.response));
}

export function fetchPageQuizResultCache({ commit }, { pageId }) {
  return http.get(`${MINERVA_API_URL}/pages/${pageId}/quiz_result_cache`)
    .then(resp => commit(types.SET_PAGE_QUIZ_RESULT_CACHE, resp.data))
    .catch(err => (
      err.response.status === 404
        ? commit(types.SET_PAGE_QUIZ_RESULT_CACHE, {})
        : Promise.reject(err.response)
    ));
}

export function fetchPageAnswerStatistics({ commit }, { pageId }) {
  return http.get(`${MINERVA_API_URL}/pages/${pageId}/answer_statistics`)
    .then(resp => commit(types.SET_PAGE_ANSWER_STATISTICS, resp.data))
    .catch(err => Promise.reject(err.response));
}

export function createUserQuestions({ dispatch }, { data }) {
  return http.post(`${MINERVA_API_URL}/user_questions`, data)
    .then(res => dispatch('setUserQuestions', res.data))
    .catch(err => Promise.reject(err.response));
}

export function setCatPagesPagination({ commit }, pagination) {
  commit(types.SET_PAGINATION, pagination);

  return Promise.resolve(pagination);
}

export function fetchCatPagesPagination({ dispatch }, { page, total }) {
  const perPage = 1;

  dispatch('setCatPagesPagination', {
    total: Number(total),
    totalPages: Number(total),
    page: Number(page),
    perPage: Number(perPage),
  });
}

export function resetSelectedOption({ commit }) {
  commit(types.RESELECT_OPTIONS);
}

export function setSelectedOption({ commit }, options) {
  commit(types.SELECT_OPTIONS, options);
}

export function setCatPagesTotal({ commit }, totalVale) {
  commit(types.SET_PAGES_TOTAL, totalVale);

  return Promise.resolve(totalVale);
}

export function resetCatQuizStartTime({ commit }) {
  return commit(types.RESET_QUIZ_START_TIME);
}

export function setUserQuestions({ commit }, data) {
  commit(types.SET_USER_QUESTIONS, data);

  return Promise.resolve(data);
}
